import React, { Suspense, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  FormContainer,
  FormBackground,
} from '../../CreateRoutes/CreateForm.styles';
const ResultModal = React.lazy(
  () => import('../../../Components/Modal/ResultModal.component')
);
const CompanyInfo = React.lazy(
  () => import('../../../Components/CompanyForm/CompanyInfo')
);
const LogoInput = React.lazy(
  () => import('../../../Components/Form/LogoInput')
);
const AddressComponent = React.lazy(
  () => import('../../../Components/CompanyForm/Address')
);
const EditFormButtons = React.lazy(
  () => import('./EditButtonsComponent.component')
);
const BreadCrumbs = React.lazy(
  () => import('../../../Components/Breadcrumbs/BreadcrumbsComponent.component')
);
const PageScroller = React.lazy(
  () => import('../../../Components/PageScroller/PageScroller.component')
);

const CompanyEditInnerComponent = ({ c }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [logo, setLogo] = useState('');
  const [successState, setSuccessState] = useState('');
  const [company, setCompany] = useState(c || {});
  const [address, setAddress] = useState(c?.address || []);

  useEffect(() => {
    setCompany(c);
    setAddress(c?.address[0]);
  }, [c]);

  return (
    <>
      <FormContainer>
        <Suspense fallback={<p>Loading breadcrumbs...</p>}>
          <BreadCrumbs
            one="Company Info (Admin)"
            oneLink={`/admin/company-home/${c?._id}`}
            two="Edit Company"
          />
        </Suspense>
        <h2>Edit Company</h2>
        <form>
          <FormBackground>
            <Suspense fallback={<p>Loading company info...</p>}>
              <CompanyInfo company={company} setCompany={setCompany} />
            </Suspense>
            <Suspense fallback={<p>Loading address form...</p>}>
              <AddressComponent
                billingAddress={address}
                setBillingAddress={setAddress}
              />
            </Suspense>
            <Suspense fallback={<p>Loading logo input...</p>}>
              <LogoInput logo={logo} setLogo={setLogo} />
            </Suspense>
          </FormBackground>
          <Suspense fallback={<p>Loading result modal...</p>}>
            <ResultModal
              isOpen={isOpen}
              onClose={() => setIsOpen(false)}
              result={successState}
              linkTo="/admin"
            />
          </Suspense>
          <Suspense fallback={<p>Loading form buttons...</p>}>
            <EditFormButtons
              company={company}
              address={address}
              setIsOpen={setIsOpen}
              successState={successState}
              setSuccessState={setSuccessState}
              logo={logo}
            />
          </Suspense>
        </form>
        <Suspense fallback={<p>Loading page scroller...</p>}>
          <PageScroller />
        </Suspense>
      </FormContainer>
    </>
  );
};
CompanyEditInnerComponent.propTypes = {
  c: PropTypes.shape({
    _id: PropTypes.string,
    address: PropTypes.array,
  }),
};

export default CompanyEditInnerComponent;
